import React from "react";
// import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';

import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { store } from "src/Redux/store";
import { Provider } from "react-redux";

import { StyledEngineProvider } from "@mui/material/styles";

// const root = ReactDOM.createRoot(document.getElementById("root"));
const root = createRoot(document.getElementById('root'));

root.render(
  <StyledEngineProvider injectFirst>
    {/* for material UI date-time picker */}
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  </StyledEngineProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
